import React from "react";
import bazaarImg from "../../assets/Images/secondhand-bazaar.png";
import techImage from "../../assets/Images/tech-maintenance.png";
import eSchoolImage from "../../assets/Images/e-school.png";
import Project from "./Project";

const data = [
  {
    _id: 1,
    images: [
      {
        image:
          "https://res.cloudinary.com/dzrf760el/image/upload/v1670743593/My-Portfolio/secondhand-bazaar_xmekgv.png",
        caption: "",
      },
      {
        image:
          "https://res.cloudinary.com/dzrf760el/image/upload/v1670743594/My-Portfolio/secondhand-bazaar-1_nwm6ic.png",
        caption: "",
      },
      {
        image:
          "https://res.cloudinary.com/dzrf760el/image/upload/v1670743594/My-Portfolio/secondhand-bazaar-3_aerwnr.png",
        caption: "",
      },
      {
        image:
          "https://res.cloudinary.com/dzrf760el/image/upload/v1670743594/My-Portfolio/secondhand-bazaar-2_abie68.png",
        caption: "",
      },
    ],
    title: "Secondhand Bazaar - Resale Market",
    description:
      "Secondhand computer part selling website. You can find items of different categories",
    bulletPoints: [
      "3 types of user (buyer, seller, admin) each with different private dashboards.",
      "Seller can add, remove, advertise products and see if item is bought. Buyer can buy, make payments.",
      "Admin can verify seller, remove buyer, remove seller, remove reported products.",
      "Firebase authentication and JWT based authorization is used to maintain security.",
      "Express is used on server and MongoDb is used as database."
    ],
    technologies: [
      "React",
      "React-Query",
      "Firebase",
      "React-Hook-Form",
      "Axios",
      "TailwindCSS",
      "Stripe",
      "Express",
      "MongoDB",
    ],
    client: "https://github.com/comconToukir/secondhand-bazaar-resale-market-client",
    server:
      "https://github.com/comconToukir/secondhand-bazaar-resale-market-server",
    liveSite: "https://secondhand-bazaar.web.app/",
  },
  {
    _id: 2,
    images: [
      {
        image:
          "https://res.cloudinary.com/dzrf760el/image/upload/v1670743595/My-Portfolio/tech-maintenance_okwv4z.png",
        caption: "",
      },
      {
        image:
          "https://res.cloudinary.com/dzrf760el/image/upload/v1670743597/My-Portfolio/tech-maintenance-1_pxwlnt.png",
        caption: "",
      },
      {
        image:
          "https://res.cloudinary.com/dzrf760el/image/upload/v1670743595/My-Portfolio/tech-maintenance-2_zpmeui.png",
        caption: "",
      },
      {
        image:
          "https://res.cloudinary.com/dzrf760el/image/upload/v1670743595/My-Portfolio/tech-maintenance-3_gt2xq0.png",
        caption: "",
      },
    ],
    title: "Tech Maintenance - Service Site",
    description:
      "A website that provides maintenance service. Get all services from one location.",
    bulletPoints: [
      "MERN stack site with crud operation, firebase authentication & jwt based authorization.",
      "User can see services, add a service (cloudinary image upload), add, edit & delete review.",
      "Used react query for data fetching and synchronization, tailwind for design.",
      "In service details user can see the service price, rating, reviews etc.",
      "In the blog page there are some web development related questions and their answers."
    ],
    technologies: [
      "React",
      "React-Query",
      "Firebase",
      "Tailwindcss",
      "ExpressJs",
      "MongoDB",
      "Cloudinary",
      "jwt",
    ],
    client: "https://github.com/comconToukir/tech-maintenance-service-client",
    server: "https://github.com/comconToukir/tech-maintenance-service-server",
    liveSite: "https://phero-assignment-main.web.app/",
  },
  {
    _id: 3,
    images: [
      {
        image:
          "https://res.cloudinary.com/dzrf760el/image/upload/v1670743598/My-Portfolio/e-school_tpagti.png",
        caption: "",
      },
      {
        image:
          "https://res.cloudinary.com/dzrf760el/image/upload/v1670743595/My-Portfolio/e-school-1_rapwf9.png",
        caption: "",
      },
      {
        image:
          "https://res.cloudinary.com/dzrf760el/image/upload/v1670743596/My-Portfolio/e-school-2_y3juce.png",
        caption: "",
      },
      {
        image:
          "https://res.cloudinary.com/dzrf760el/image/upload/v1670743596/My-Portfolio/e-school-3_b1eeq8.png",
        caption: "",
      },
    ],
    title: "E-School Learning Platform",
    description:
      "A learning platform for various topics. Learn from the comfort of home.",
    bulletPoints: [
      "React site with express server, firebase authentication, basic authorization, day/night theme.",
      "User can dynamically view different courses of different categories (used react-query).",
      "User can update name, profile image, email, password and reset password.",
      "In course details user can see the course price, rating, description, student feedback etc.",
      "User can reset email, password, profile name, profile picture"
    ],
    technologies: [
      "React",
      "React-Query",
      "Firebase",
      "React-Hook-Form",
      "React-Icons",
      "React-Hot-Toast",
      "ExpressJs",
    ],
    client: "https://github.com/comconToukir/e-school-learning-platform-client",
    server: "https://github.com/comconToukir/e-school-learning-platform-server",
    liveSite: "https://learning-platform-e-school.web.app/",
  },
];

const MyProjects = () => {
  return (
    <section className="mt-24" id="my-projects">
      <h2 className="text-cyan-300 text-2xl font-medium text-center mb-12 ">
        <span className="">My Recent Projects</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {data.map((project) => (
          <Project key={project._id} project={project} />
        ))}
      </div>
    </section>
  );
};

export default MyProjects;
